module.exports = __webpack_public_path__ + "img/full4-min.a8e7e816.png";